<template>
  <div id="app" :class="mqClass">
    <ScrollyMap :isMobile="isMobile" :debug="debug" />
  </div>
</template>

<script>
// For testing vue2-leaflet plugin
// import TestMap from './components/TestMap'
import ScrollyMap from './components/ScrollyMap'
import Modernizr from 'modernizr';

export default {
  name: 'App',
  components: {
    ScrollyMap
  },
  data () {
    return {
      deviceBySize: '',
      debug: false
    }
  },
  computed: {
    mqClass () {
      return 'mq-' + this.deviceBySize;
    },
    isMobile () {
      return this.deviceBySize == 'mobile';
    }
  },
  methods: {
    handleTouchstart () {
      // Use this to double-check we have disabled map scroll for touch devices
      this.deviceBySize = 'mobile';
    },
    setDevice () {
      this.deviceBySize = 'desktop';

      if(Modernizr.mq('(max-width: 900px)')) {
        this.deviceBySize = 'mobile';
      }
    }
  },
  mounted: function () {
    // Check for changes in timeline width on resize
    window.addEventListener('touchstart', this.handleTouchstart);
    window.addEventListener('resize', this.setDevice);
    this.setDevice();
  },
  beforeDestroy: function () {
    window.removeEventListener('touchstart', this.handleTouchstart);
    window.removeEventListener('resize', this.setDevice);
  }
}
</script>

<style lang="scss">
@import 'leaflet/dist/leaflet.css';
/* Leaflet overrides */
.leaflet-top {
  top: 10vw;
  z-index: auto;
}
.leaflet-bottom {
  z-index: auto;
}
.leaflet-control-attribution a,
.leaflet-control-attribution a:hover {
  color: black;
}
.leaflet-interactive {
	cursor: grab;
}

@import '~styles/fonts.scss';
@import '~styles/variables.scss';

html, body {
  padding: 0;
  margin: 0;
  color: $darkTextColor;
  font-family: $sans;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
}

p {
  line-height: 1.45;
}

a {
  color: $linkColor;
}
a:hover {
  color: $linkHoverColor;
}
.split {
  float: left;
  box-sizing: border-box;
  width: 50%;
  &.left {
    clear: left;
  }
  &.right {
    float: right;
    clear: right;
  }
}
.icon {
  display: inline-block;
  vertical-align: middle;
  background-size: cover;
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.screenReaderOnly {
  position:absolute;
  left:-10000px;
  top:auto;
  width:1px;
  height:1px;
  overflow:hidden;
}

.mq-mobile {
  .split {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue